export const homeStories = [
  {
    destination: "Kumarakom",
    description: ` Mist-clad hills, romantic locales, spashy waterfalls, sprawling tea plantations... 
    Munnar is the most-loved hill station in Kerala for travellers around the world.`,
    storyVideo: "homeStories/backWater.mp4",
  },
  {
    destination: "Kovalam",
    description: `With its picture-perfect beauty, luscious mangroves, queues of coconut palm & quaint village life, 
    Kumarakom in Kottayam district is a medley of rustic experiences`,
    storyVideo: "homeStories/beaches.mp4",
  },
  {
    destination: "Munnar",
    description: ` With its crescent-shaped, palm-fringed beaches and golden sands, Kovalam charms travellers with its aura and enrich them 
      \n with a multitude of experiences.`,
    storyVideo: "homeStories/hillStation.mp4",
  },
  {
    destination: "Athirappilly",
    description: `The sight of the water crashing onto the ground amid lush green environs leaves 
    you with a sense of wonder at the sheer power and magnificence of nature.`,
    storyVideo: "homeStories/waterfalls.mp4",
  },
];

export const whatsNewItems = [
  {
    heading: `Covid-19 restrictions \n &amp; advisory`,
    description: `The Government of Kerala is taking proactive measures to stop the spread of the virus.
            Get to know about all the important messages and advisories related to travel issued by the government here.`,
    imgUrl: "whatNew/essentialSlide1.jpg",
    mobileImgUrl: "whatNew/view-mobile.jpg",
  },
  {
    heading: "Go caravanning!",
    description: `&lsquo;Keravan Kerala&rsquo;, is set to change the way travellers experience God's Own Country.
        Travellers can hire custom-built tourist caravans with state-of-the-art facilities and go off the beaten track in Kerala.`,
    imgUrl: "whatNew/go-caravan.jpg",
    mobileImgUrl: "whatNew/view-mobile.jpg",
  },
  {
    heading: "Kerala365",
    description: `It&rsquo;s time to discover new vistas!
        Every day, experience a slice of Kerala from the comfort of your couch and get inspired for a dream trip to the land where the tourism season never ends. #LetsTravelKerala`,
    imgUrl: "whatNew/kerala-365.jpg",
    mobileImgUrl: "whatNew/view-mobile.jpg",
  },
];

export const memoriesItems = [
  {
    heading: `Feel the clouds, feel the mist`,
    description: `Trek to Meesapulimala and enjoy hiking above the milky clouds. A perfect destination for adventure junkies, this second highest peak in the Western Ghats offers you trekking and camping facilities.`,
    imgUrl: "memoriesKerala/memoriesBg1.jpg",
    href: "#",
  },
  {
    heading: `My Jumbo Stories`,
    description: `Head over to Kottur and experience the charm of a world unbeknownst to you - the fascinating world of elephants. Watch the black beauties, both big and small, plunge in for their joyful dip and redraw the figures in the Neyyar reservoir.`,
    imgUrl: "memoriesKerala/memoriesBg2.jpg",
    href: "#",
  },
  {
    heading: `Sun above, sand below`,
    description: `Explore some of the spectacular beaches in Kerala that will take your breath away. The Kerala coast is replete with exotic resorts and hotels where travellers can spend their time sunbathing, swimming or simply enjoying the stunning view.`,
    imgUrl: "memoriesKerala/memoriesBg3.jpg",
    href: "#",
  },
];

export const keralaStoriesItems = [
  {
    heading: `Why Kerala, India should be next on your travel bucket list`,
    description: `Everywhere you go you’re greeted with a warm smile. The kindness of strangers in Kerala is incredible, from north to south everyone flashed us a smile, took an interest on where we were from and loved a selfie or two!`,
    imgUrl: "keralaStories/storiesBg1.jpg",
    mobileImgUrl: "keralaStories/stories-mobileBg.jpg",
    authorImgUrl: "keralaStories/avatarBg.png",
    authorName: `Giana Spiteri`,
    profileTitle: `A lifestyle and travel blogger from Gibralter`,
  },

  {
    heading: `Why Kerala, India should be next on your travel bucket list`,
    description: `Everywhere you go you’re greeted with a warm smile. The kindness of strangers in Kerala is incredible, from north to south everyone flashed us a smile, took an interest on where we were from and loved a selfie or two!`,
    imgUrl: "keralaStories/storiesBg2.jpg",
    mobileImgUrl: "keralaStories/stories-mobileBg.jpg",
    authorImgUrl: "keralaStories/avatarBg.png",
    authorName: `Giana Spiteri`,
    profileTitle: `A lifestyle and travel blogger from Gibralter`,
  },
];

export const destinationItems = [
  {
    heading: `Varkala`,
    description: `Towering laterite cliffs overlook the serene sea along the beach`,
    href: "#",
    district: `Thiruvananthapuram`,
    imgUrl: "discoverKerala/discover1.jpg",
    imgMap: "discoverKerala/map/kerala-trivandrum-map.png",
    imgFav: "discoverKerala/favourite_yellow.svg",
  },
  {
    heading: `Fort Kochi`,
    description: `A perfect blend of colonial Dutch, Portuguese and British culture`,
    district: `Ernakulam`,
    imgUrl: "discoverKerala/discover2.jpg",
    imgMap: "discoverKerala/map/kerala-ernakulam-map.png",
  },
  {
    heading: `Kasaragod`,
    description: `A Saga of Forts, Folklores and Festivals`,
    district: `Kasaragod`,
    imgUrl: "discoverKerala/discover3.jpg",
    imgMap: "discoverKerala/map/kerala-ernakulam-map.png",
  },
  {
    heading: `Kumarakom`,
    description: `The cradle of Responsible Tourism in Kerala`,
    district: `Kottayam`,
    imgUrl: "discoverKerala/discover4.jpg",
    imgMap: "discoverKerala/map/kerala-kasargod-map.png",
  },
  {
    heading: `Athirappilly`,
    description: `The water cascading down the rocks enwrapped in the green magic of Western Ghats is a sight to behold`,
    district: `Thrissur`,
    imgUrl: "discoverKerala/discover5.jpg",
    imgMap: "discoverKerala/map/kerala-thrissur-map.png",
    imgFav: "discoverKerala/favourite_yellow.svg",
  },
  {
    heading: `Mannar`,
    description: `Take a stroll through the comforting constrains of this Bell metal town`,
    district: `Alappuzha`,
    imgUrl: "discoverKerala/discover6.jpg",
    imgMap: "discoverKerala/map/kerala-alappuzha-map.png",
  },
];

export const events = [
  {
    title: `Thrissur Pooram`,
    venue: `Thekkinkadu Maidanam`,
    conductingDate: "1",
    imgUrl: "discoverKerala/discover1.jpg",
    conductingMonth: "May",
    district: "Thrissur",
  },
  {
    title: `Nehru Trophy Boat Race`,
    venue: `Punnamada Lake`,
    conductingDate: "14",
    imgUrl: "discoverKerala/discover2.jpg",
    conductingMonth: "August",
    district: "Alappuzha",
  },
  {
    title: `Nishagandhi Dance & Music Festival`,
    venue: `Nishagandhi Auditorium`,
    conductingDate: "29",
    imgUrl: "discoverKerala/discover3.jpg",
    conductingMonth: "December",
    district: "TVM",
  },
  {
    title: `Thrissur Pooram`,
    venue: `Thekkinkadu Maidanam`,
    conductingDate: "1",
    imgUrl: "discoverKerala/discover4.jpg",
    conductingMonth: "May",
    district: "Thrissur",
  },
  {
    title: `Nehru Trophy Boat Race`,
    venue: `Punnamada Lake`,
    conductingDate: "14",
    imgUrl: "discoverKerala/discover5.jpg",
    conductingMonth: "August",
    district: "Alappuzha",
  },
  {
    title: `Nishagandhi Dance & Music Festival`,
    venue: `Nishagandhi Auditorium`,
    conductingDate: "29",
    imgUrl: "discoverKerala/discover6.jpg",
    conductingMonth: "December",
    district: "TVM",
  },
];

export const places = [
  {
    title: "Valiyathura Beach and Pier",
    description:
      "Away from the hustle bustle of the city is situated this beautiful beach, Valiyathura, which is one of the major fishing ports in Thiruvananthapuram.",
    mobileImgUrl: "places/places-mobile.jpg",
    imgUrl: "places/places-1.jpg",
  },
  {
    title: "Parambikulam",
    description:
      "Panoramic landscape, meandering streams, cascading waterfalls, unique trekking trails and a diverse flora and fauna — the forests of Parambikulam won't let you down.",
    mobileImgUrl: "places/places-mobile.jpg",
    imgUrl: "places/places-2.jpg",
  },
];

export const socialMediaImages = [
  {
    imgUrl: "social/socialbglg.jpg",
    socialMediaType: "fb",
  },
  {
    imgUrl: "social/social-5.jpg",
    socialMediaType: "twitter",
  },
  {
    imgUrl: "social/social-6.jpg",
    socialMediaType: "insta",
  },
  {
    imgUrl: "social/social-4.jpg",
    socialMediaType: "fb",
  },
  {
    imgUrl: "social/social-1.jpg",
    socialMediaType: "twitter",
  },
  {
    imgUrl: "social/socialbglg.jpg",
    socialMediaType: "fb",
  },
  {
    imgUrl: "social/social-5.jpg",
    socialMediaType: "twitter",
  },
  {
    imgUrl: "social/social-6.jpg",
    socialMediaType: "insta",
  },
  {
    imgUrl: "social/social-4.jpg",
    socialMediaType: "fb",
  },
  {
    imgUrl: "social/social-1.jpg",
    socialMediaType: "twitter",
  },
];
